export const delay = (t) => {
  return new Promise(function(resolve) {
    setTimeout(resolve, t);
  });
}

export const waitResizedImage = (triesRemaining, storageRef) => {
  if (triesRemaining < 0) {
    return Promise.reject("out of tries");
  }

  return storageRef
    .getDownloadURL()
    .then(url => {
      return url;
    })
    .catch(error => {
      switch (error.code) {
        case "storage/object-not-found":
          console.clear();
          return delay(2000).then(() => {
            return waitResizedImage(triesRemaining - 1, storageRef);
          });
        default:
          console.error(error);
          return Promise.reject(error);
      }
    });
};